import { configureStore } from '@reduxjs/toolkit';
import userReducer from './features/user/userSlice';
import siteReducer from './features/site/siteSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    site: siteReducer,
  },
});

export default store;
